// packages/media/isomorphic/src/mime-types.ts
var MIME_TYPES = {
  ".pdf": "application/pdf",
  ".png": "image/png",
  ".jpg": "image/jpeg",
  ".jpeg": "image/jpeg",
  ".zip": "application/zip",
  ".csv": "text/csv"
};
function inferMimeType(filename) {
  const ext = filename.slice(filename.lastIndexOf(".")).toLowerCase();
  return MIME_TYPES[ext] ?? "application/octet-stream";
}

// packages/media/isomorphic/src/upload-limits.ts
var ACCEPTED_UPLOAD_MIMES = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/jpg",
  "application/zip",
  "application/x-zip-compressed"
];
var TEN_MB = 10 * 1024 ** 2;
var TWO_GB = 2 * 1024 ** 3;
function isZipMime(mime) {
  return mime === "application/zip" || mime === "application/x-zip-compressed";
}
function isAcceptedUploadMime(mime) {
  return ACCEPTED_UPLOAD_MIMES.includes(mime);
}
function maxBytesFor(mime) {
  return isZipMime(mime) ? TWO_GB : TEN_MB;
}
var UPLOAD_CHUNK_BYTES = 8 * 1024 ** 2;
export {
  ACCEPTED_UPLOAD_MIMES,
  UPLOAD_CHUNK_BYTES,
  inferMimeType,
  isAcceptedUploadMime,
  isZipMime,
  maxBytesFor
};
//# sourceMappingURL=index.js.map
